import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import urls from "../../config/urls.json";
import { useSession } from "../../hooks/useSession";
import { useStates } from "../../hooks/useStates";
import { useAppointmentResponse } from "../../hooks/useAppointmentResponse";
import { useDynatrace } from "../../hooks/useDynatrace";

export const useClinkPage = () => {
  const navigate = useNavigate();
  const { read, update, batchUpdate } = useSession();
  const { handleAppointmentSubmission, fetchErrorMessage, fetchError, setFetchError, isCreaAppuntamentoBusy } = useAppointmentResponse();
  const { states, setCurrentState, isCreaAppuntamentoError } = useStates();

  const [vuoleRicontatto, _setVuoleRicontatto] = useState(true);

  useEffect(() => {
    setVuoleRicontatto(true);
    setCurrentState(states.CLINK_YES);
  }, []);

  const next = async () => {
    window.dataLayer.push({
      event: "click_clink",
      eventCategory: "Fissa Appuntamento",
      eventAction: "Compass Link",
      eventLabel: `Click - (${read("click_clink")})`,
    });

    if (vuoleRicontatto) {
      navigate(urls.clinkRicontatto.path, { replace: true });
    } else {
      handleAppointmentSubmission();
    }
  };

  const {} = useDynatrace();

  const setVuoleRicontatto = (ricontatto) => {
    batchUpdate({
      ricontattoCf: ricontatto,
      ricontattoLuogo: ricontatto,
      ricontatto: ricontatto,
    });
    _setVuoleRicontatto(ricontatto);

    if (true == ricontatto) {
      update("click_clink", "si");
      setCurrentState(states.CLINK_YES);
    } else {
      update("click_clink", "no");
      setCurrentState(states.CLINK_NO);
    }
  };

  return {
    next,
    read,
    vuoleRicontatto,
    setVuoleRicontatto,
    isCreaAppuntamentoError,
    fetchErrorMessage,
    fetchError,
    setFetchError,
    isCreaAppuntamentoBusy,
  };
};
